import { signingProviderConstants } from "../../../constants/SigningProviderConstants";
import { signingProviderService } from "../../services/vorgange/signingProviderService";

const getProviders = (personType) => async (dispatch) => {
  dispatch({ type: signingProviderConstants.PROVIDERS_REQUEST });
  try {
    const response = await signingProviderService.getProviders(personType);
    dispatch({
      type: signingProviderConstants.PROVIDERS_SUCCESS,
      providers: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: signingProviderConstants.PROVIDERS_FAILURE,
      error: error.message,
    });
    return [];
  }
};

const selectProvider = (providerId) => async (dispatch) => {
  const response = await signingProviderService.selectProvider(providerId);
  dispatch({
    type: signingProviderConstants.SELECT_PROVIDER,
    provider: response.data,
  });
  return response.data;
};

const getRepresentatives = () => async (dispatch) => {
  dispatch({ type: signingProviderConstants.REPRESENTATIVES_REQUEST });
  try {
    const response = await signingProviderService.getRepresentatives();
    dispatch({
      type: signingProviderConstants.REPRESENTATIVES_SUCCESS,
      representatives: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: signingProviderConstants.REPRESENTATIVES_FAILURE,
      error: error.message,
    });
    return [];
  }
};

const getSigningCase = (requestId) => async (dispatch) => {
  const response = await signingProviderService.getSigningCase(requestId);
  dispatch({
    type: signingProviderConstants.SIGNING_CASE_SUCCESS,
    signingCase: response.data,
  });
  return response.data;
};

const createSigningCase = (requestId, signingData) => async (dispatch) => {
  dispatch({ type: signingProviderConstants.SIGNING_CASE_REQUEST });
  const response = await signingProviderService.createSigningCase(
    requestId,
    signingData
  );

  if (response.status === 200) {
    dispatch({
      type: signingProviderConstants.SIGNING_CASE_SUCCESS,
      signingCase: response.data,
    });
  } else {
    dispatch({
      type: signingProviderConstants.SIGNING_CASE_FAILURE,
      validationMessages: response.data.validationMessages,
    });
  }
  return response;
};

const cancelSigningCase = (requestId) => async (dispatch) => {
  await signingProviderService.cancelSigningCase(requestId);
  dispatch({ type: signingProviderConstants.SIGNING_CASE_CANCEL_SUCCESS });
};

const downloadPrefilledDocuments =
  (requestId, isPPOA = false) =>
  async () =>
    signingProviderService.downloadPrefilledDocuments(requestId, isPPOA);

const downloadSigningDocument = (requestId, documentId) => async () =>
  signingProviderService.downloadSigningDocument(requestId, documentId);

const startVerification =
  (requestId, providerId, additionalFields, isPPOA = false) =>
  async () => {
    const response = await signingProviderService.startVerification(
      requestId,
      providerId,
      additionalFields,
      isPPOA
    );

    return response;
  };

const submitSigners =
  (requestId, signers, isPPOA = false) =>
  async () =>
    signingProviderService.submitSigners(requestId, signers, isPPOA);

const resetSigningFlow = () => ({
  type: signingProviderConstants.SIGNING_FLOW_RESET,
});

export const signingProviderActions = {
  getProviders,
  selectProvider,
  getRepresentatives,
  getSigningCase,
  createSigningCase,
  cancelSigningCase,
  downloadPrefilledDocuments,
  downloadSigningDocument,
  startVerification,
  submitSigners,
  resetSigningFlow,
};
